import { IconButton, InputAdornment, TextField } from "@mui/material";
import { CpfMask } from "../../../../components/Mask/DelendTextMask";
import ClearInputIcon from "../../../../components/Vectors/ClearInputIcon";
import { FieldErrors } from "react-hook-form";
import { LegalPersonInput } from "../../validation";

interface CpfInputProps {
  register: any;
  errors: FieldErrors<LegalPersonInput>;
  getValues: any;
  resetField: any;
}

const CpfInput: React.FC<CpfInputProps> = ({
  register,
  errors,
  getValues,
  resetField,
}) => {
  return (
    <TextField
      fullWidth
      {...register("responsibleCpf")}
      label="CPF"
      required
      error={!!errors.responsibleCpf}
      helperText={errors.responsibleCpf?.message}
      variant="standard"
      inputProps={{
        style: {
          fontSize: 16,
          height: 30,
        },
      }}
      InputProps={{
        inputComponent: CpfMask as any,
        endAdornment: !!errors.responsibleCpf &&
          getValues("responsibleCpf") && (
            <InputAdornment sx={{ marginRight: "-5px" }} position="end">
              <IconButton
                aria-label="Apagar campo"
                onClick={() => {
                  resetField("responsibleCpf");
                }}
              >
                <ClearInputIcon />
              </IconButton>
            </InputAdornment>
          ),
      }}
    />
  );
};

export default CpfInput;
